import styled from 'styled-components'

const UploadFileStyle = styled.div`
  position: relative;
  width: 140px;
  height: 36px;
  * {
    width: 100%;
    height: 100%;
  }
  label,
  input {
    font-size: 11px;
    line-height: 3.3;
    position: absolute;
    top: 0;
    left: 0;
    &:hover {
      cursor: pointer;
    }
  }
  input {
    visibility: hidden;
  }
  .button {
    background: ${props => props.theme.palette.primary.main};
    color: #fff;
    border-radius: 4px;
    text-align: center;
  }

  .buttonOutlined {
    color: ${props => props.theme.palette.primary.main};
    border: 1px solid ${props => props.theme.palette.primary.main};
    border-radius: 4px;
    text-align: center;
  }
`

export default UploadFileStyle
